/* CARBON-X interactions */
(() => { const init=()=>{document.querySelectorAll('[data-menu-toggle]').forEach(b=>{if(b.dataset.ready)return;b.dataset.ready='1';const m=document.querySelector('[data-mobile-menu]');if(!m)return;b.addEventListener('click',()=>{const o=m.classList.toggle('is-open');b.setAttribute('aria-expanded',o?'true':'false')});m.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>m.classList.remove('is-open')))});document.querySelectorAll('.cx-reveal').forEach(x=>{if('IntersectionObserver' in window){const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.12});io.observe(x)}else x.classList.add('is-visible')});document.querySelectorAll('[data-scroll-link]').forEach(a=>a.addEventListener('click',e=>{const href=a.getAttribute('href')||'';if(href.includes('#products')&&location.pathname===new URL(href,location.href).pathname){e.preventDefault();document.querySelector('#products')?.scrollIntoView({behavior:'smooth'})}}));};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();})();

(() => {
  const money = c => { try { return new Intl.NumberFormat(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'INR',maximumFractionDigits:0}).format(c/100); } catch(e){ return '₹'+Math.round(c/100); } };
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const open = () => { const d=drawer(); if(!d)return; d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); document.body.classList.add('cx-cart-open'); };
  const close = () => { const d=drawer(); if(!d)return; d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); document.body.classList.remove('cx-cart-open'); };
  const escape = s => String(s||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const render = cart => { const d=drawer(); if(!d)return; d.querySelectorAll('[data-cart-drawer-count]').forEach(x=>x.textContent='('+cart.item_count+')'); document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=cart.item_count); const body=d.querySelector('[data-cart-body]'); const footer=d.querySelector('.cx-cart-drawer__footer'); if(footer)footer.remove(); if(!cart.item_count){body.innerHTML='<div class="cx-cart-empty"><p>Your bag is waiting for something useful.</p><a class="cx-btn cx-btn--green" href="/\#products" data-cart-close>Continue shopping</a></div>';return;} body.innerHTML=cart.items.map(i=>`<div class="cx-cart-line" data-cart-line data-key="${escape(i.key)}"><a class="cx-cart-line__image" href="${i.url}">${i.image?`<img src="${i.image}" alt="${escape(i.product_title)}">`:''}</a><div class="cx-cart-line__details"><a href="${i.url}">${escape(i.product_title)}</a>${i.variant_title?`<p>${escape(i.variant_title)}</p>`:''}<strong>${money(i.final_line_price)}</strong><div class="cx-qty"><button type="button" data-cart-change data-line="${escape(i.key)}" data-quantity="${i.quantity-1}">−</button><span>${i.quantity}</span><button type="button" data-cart-change data-line="${escape(i.key)}" data-quantity="${i.quantity+1}">+</button></div></div><button class="cx-cart-line__remove" type="button" data-cart-change data-line="${escape(i.key)}" data-quantity="0">×</button></div>`).join(''); d.querySelector('.cx-cart-drawer__panel').insertAdjacentHTML('beforeend',`<footer class="cx-cart-drawer__footer"><div><span>Subtotal</span><strong data-cart-total>${money(cart.total_price)}</strong></div><p>Taxes and shipping calculated at checkout.</p><form action="/cart" method="post"><button class="cx-btn cx-btn--green cx-btn--full" name="checkout" type="submit">Secure checkout</button></form></footer>`); };
  const refresh = async() => { const r=await fetch('/cart.js'); render(await r.json()); };
  document.addEventListener('click',async e=>{ const openBtn=e.target.closest('[data-cart-open]'); if(openBtn){e.preventDefault();open();return;} if(e.target.closest('[data-cart-close]')){e.preventDefault();close();return;} const ch=e.target.closest('[data-cart-change]'); if(ch){e.preventDefault(); ch.disabled=true; try{const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:ch.dataset.line,quantity:Number(ch.dataset.quantity)})}); if(r.ok)render(await r.json());}finally{ch.disabled=false;}} });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  document.querySelectorAll('form[data-cart-form]').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault(); const buy=e.submitter?.hasAttribute('data-buy-now'); const b=e.submitter; if(b)b.disabled=true; try{const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)}); if(!r.ok)throw new Error(); if(buy){location.href='/checkout';return;} await refresh();open();}catch(err){alert('Unable to add this product. Please try again.')}finally{if(b)b.disabled=false;}}));
})();

/* CARBON-X cinematic header state */
(() => {
  const initSeattleHeader = () => {
    const h = document.querySelector('[data-seattle-header]');
    if (!h || h.dataset.seattleReady) return;
    h.dataset.seattleReady = '1';
    const progress = h.querySelector('[data-header-progress]');
    let ticking = false;
    const sync = () => {
      const y = window.scrollY || 0; h.classList.toggle('is-sticky', y > 36);
      if (progress) {
        const max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
        progress.style.width = `${Math.min(100, Math.max(0, y / max * 100))}%`;
      }
      ticking = false;
    };
    const requestSync = () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } };
    sync();
    window.addEventListener('scroll', requestSync, {passive:true});
    window.addEventListener('resize', requestSync, {passive:true});
    document.querySelectorAll('.cx-seattle-mobile [data-menu-toggle]').forEach(b => b.addEventListener('click', () => {
      const m = document.querySelector('.cx-seattle-mobile');
      if (m) m.classList.remove('is-open');
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSeattleHeader);
  else initSeattleHeader();
})();


/* Subtle cinematic hero parallax, desktop only */
(() => {
  const setupHeroParallax = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(min-width: 901px)').matches) return;
    const hero = document.querySelector('.cx-hero--editorial .cx-hero__media');
    const media = hero?.querySelector('img, video');
    if (!hero || !media || hero.dataset.parallaxReady) return;
    hero.dataset.parallaxReady = '1';

    let raf = 0;
    let tx = 0, ty = 0, cx = 0, cy = 0;
    const update = () => {
      cx += (tx - cx) * 0.07;
      cy += (ty - cy) * 0.07;
      media.style.transform = `translate3d(${cx}px,${cy}px,0) scale(1.045)`;
      raf = requestAnimationFrame(update);
    };
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - .5) * -10;
      ty = ((e.clientY - r.top) / r.height - .5) * -7;
      if (!raf) raf = requestAnimationFrame(update);
    });
    hero.addEventListener('pointerleave', () => { tx = 0; ty = 0; });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupHeroParallax);
  else setupHeroParallax();
})();


/* CARBON-X header state: transparent at top, beige while scrolling */
(() => {
  const initCarbonXHeaderState = () => {
    const header = document.querySelector('.cx-header--seattle');
    if (!header || header.dataset.cxHeaderStateReady) return;
    header.dataset.cxHeaderStateReady = '1';

    const update = () => {
      header.classList.toggle('is-sticky', window.scrollY > 24);
    };
    update();
    window.addEventListener('scroll', update, {passive:true});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarbonXHeaderState);
  } else {
    initCarbonXHeaderState();
  }
})();

/* CARBON-X product micro-motion: a gentle hover lift for the editorial media,
   deliberately subtle so the product remains the hero, not the animation. */
(() => {
  const cxProductMicroMotion = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.cx-product-card--editorial .cx-product-card__media').forEach(media => {
      if (media.dataset.motionReady) return;
      media.dataset.motionReady = '1';
      media.addEventListener('pointermove', e => {
        if (window.matchMedia('(max-width: 900px)').matches) return;
        const r = media.getBoundingClientRect();
        const x = ((e.clientX-r.left)/r.width-.5)*-5;
        const y = ((e.clientY-r.top)/r.height-.5)*-4;
        const img = media.querySelector('.cx-product-card__image');
        if (img) img.style.transform = `scale(.98) translate3d(${x}px,${y}px,0)`;
      });
      media.addEventListener('pointerleave', () => {
        const img = media.querySelector('.cx-product-card__image');
        if (img) img.style.transform = '';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cxProductMicroMotion);
  else cxProductMicroMotion();
})();


/* CARBON-X premium product page interactions */
(() => {
  const initProductExperience = () => {
    document.querySelectorAll('[data-cx-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready='1';
      const main=gallery.querySelector('[id^="cx-product-main-image-"]');
      gallery.querySelectorAll('[data-cx-gallery-thumb]').forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          if (!main) return;
          main.src=thumb.dataset.full;
          main.removeAttribute('srcset');
          main.alt=thumb.dataset.alt || '';
          gallery.querySelectorAll('[data-cx-gallery-thumb]').forEach(t=>t.classList.remove('is-active'));
          thumb.classList.add('is-active');
          const count=gallery.querySelector('.cx-product-gallery__count');
          if(count) count.textContent=String(i+1).padStart(2,'0')+' / '+String(gallery.querySelectorAll('[data-cx-gallery-thumb]').length).padStart(2,'0');
        });
      });
    });

    document.querySelectorAll('[data-cx-quantity]').forEach(button => {
      if(button.dataset.ready) return;
      button.dataset.ready='1';
      button.addEventListener('click', () => {
        const wrap=button.closest('.cx-quantity');
        const input=wrap?.querySelector('input');
        if(!input) return;
        const next=Math.max(1,(parseInt(input.value||'1',10)||1)+Number(button.dataset.cxQuantity||0));
        input.value=next;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });

    /* Resolve selected product options to the correct variant ID before
       the normal CARBON-X cart handler submits the form. */
    document.querySelectorAll('.cx-product-form--8style').forEach(form => {
      if(form.dataset.variantReady) return;
      form.dataset.variantReady='1';
      const dataEl=form.closest('.cx-product-page')?.querySelector('[data-cx-product-data]');
      if(!dataEl) return;
      let product;
      try { product=JSON.parse(dataEl.textContent); } catch(e){ return; }
      const page=form.closest('.cx-product-page');
      const priceData=page?.querySelector('[data-cx-variant-price-data]');
      const priceEl=page?.querySelector('[data-cx-product-price]');
      const compareEl=page?.querySelector('[data-cx-product-compare]');
      const stockEl=page?.querySelector('.cx-product-info__topline span:first-child');
      const sticky=document.querySelector('.cx-sticky-product-buy');
      const stickyId=sticky?.querySelector('input[name="id"]');
      const stickyPrice=sticky?.querySelector('[data-cx-sticky-price]');
      const stickyCompare=sticky?.querySelector('[data-cx-sticky-compare]');
      const stickyButton=sticky?.querySelector('button[type="submit"]');
      const sync=()=>{
        const choices=[...form.querySelectorAll('[data-cx-option-input]:checked')].map(x=>x.value);
        const variant=product.variants.find(v=>v.options.every((o,i)=>o===choices[i]));
        if(!variant) return;
        const id=form.querySelector('[data-cx-variant-id]');
        if(id) id.value=variant.id;
        form.querySelectorAll('button[type="submit"]').forEach(b=>b.disabled=!variant.available);
        form.querySelectorAll('.cx-product-form__fieldset').forEach(fieldset=>{
          const selected=fieldset.querySelector('[data-cx-option-input]:checked');
          const valueEl=fieldset.querySelector('legend span');
          if(selected && valueEl) valueEl.textContent=selected.value;
        });
        const variantPriceData=priceData ? [...priceData.querySelectorAll('[data-cx-variant-price-id]')].find(x=>x.dataset.cxVariantPriceId===String(variant.id)) : null;
        const formattedPrice=variantPriceData?.dataset.price || '';
        const formattedCompare=variantPriceData?.dataset.compare || '';
        if(priceEl && formattedPrice) priceEl.textContent=formattedPrice;
        if(compareEl){
          compareEl.textContent=formattedCompare;
          compareEl.hidden=!formattedCompare;
        }
        if(stockEl) stockEl.textContent=variant.available ? 'In stock' : 'Currently unavailable';
        if(stickyId) stickyId.value=variant.id;
        if(stickyPrice && formattedPrice) stickyPrice.textContent=formattedPrice;
        if(stickyCompare){
          stickyCompare.textContent=formattedCompare;
          stickyCompare.hidden=!formattedCompare;
        }
        if(stickyButton) stickyButton.disabled=!variant.available;
      };
      form.querySelectorAll('[data-cx-option-input]').forEach(i=>i.addEventListener('change',sync));
      sync();
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initProductExperience);
  else initProductExperience();
})();

/* CARBON-X: homepage product-card variant picker + pricing */
(() => {
  const initProductCardVariants = () => {
    document.querySelectorAll('.cx-product-card--premium').forEach(card => {
      const form = card.querySelector('.cx-product-card__form');
      const optionInputs = [...card.querySelectorAll('[data-cx-card-option-input]')];
      const variantId = form?.querySelector('[data-cx-card-variant-id]');
      const price = card.querySelector('[data-cx-card-price]');
      const compare = card.querySelector('[data-cx-card-compare]');
      const variantData = card.querySelector('[data-cx-card-variant-data]');
      const variants = variantData ? [...variantData.querySelectorAll('[data-cx-card-variant]')] : [];
      if (!form || !optionInputs.length || !variantId || !price || !variants.length || form.dataset.variantReady) return;
      form.dataset.variantReady='1';

      const findVariantRow = () => {
        const choices = [];
        optionInputs.forEach(input => {
          if (input.checked) choices[Number(input.dataset.optionIndex)] = String(input.value).trim();
        });
        const optionCount = Math.max(1, optionInputs.reduce((max, input) => Math.max(max, Number(input.dataset.optionIndex) + 1), 0));
        if (choices.length < optionCount || choices.some(value => value == null || value === '')) return null;

        return variants.find(row => {
          for (let i = 0; i < optionCount; i++) {
            const rowValue = String(row.getAttribute(`data-option-${i + 1}`) || '').trim();
            if (rowValue !== choices[i]) return false;
          }
          return true;
        }) || null;
      };

      const sync = () => {
        const row = findVariantRow();
        if (!row) return;

        const id = row.dataset.variantId;
        const formattedPrice = row.dataset.price || '';
        const formattedCompare = row.dataset.compare || '';
        const available = row.dataset.available === 'true';

        variantId.value = id;
        price.textContent = formattedPrice;
        if (compare) {
          compare.textContent = formattedCompare;
          compare.hidden = !formattedCompare;
        }

        form.querySelectorAll('.cx-product-card__actions button[type="submit"]').forEach(button => {
          button.disabled = !available;
        });

        form.querySelectorAll('.cx-product-form__fieldset').forEach(fieldset => {
          const selected = fieldset.querySelector('[data-cx-card-option-input]:checked');
          const valueEl = fieldset.querySelector('legend span');
          if (selected && valueEl) valueEl.textContent = selected.value;
        });
      };

      optionInputs.forEach(input => {
        input.addEventListener('change', sync);
        input.addEventListener('input', sync);
      });

      sync();
    });
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initProductCardVariants);
  else initProductCardVariants();
})();

/* CARBON-X: product card canvas navigation */
(() => {
  const initClickableCards = () => {
    document.querySelectorAll('[data-product-card]').forEach(card => {
      if(card.dataset.clickReady) return;
      card.dataset.clickReady='1';
      card.addEventListener('click', e => {
        if(e.target.closest('a,button,select,input,textarea,label,form')) return;
        const url=card.dataset.productUrl;
        if(url) window.location.href=url;
      });
      card.addEventListener('keydown', e => {
        if((e.key==='Enter'||e.key===' ') && !e.target.closest('a,button,select,input,textarea,form')){
          e.preventDefault();
          const url=card.dataset.productUrl;
          if(url) window.location.href=url;
        }
      });
      card.setAttribute('tabindex','0');
      card.setAttribute('role','link');
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initClickableCards);
  else initClickableCards();
})();


/* CARBON-X editable collection carousel */
(() => {
  const initCollectionCarousels = () => {
    document.querySelectorAll('[data-cx-carousel]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready='1';
      const track=section.querySelector('[data-cx-carousel-track]');
      const prev=section.querySelector('[data-cx-carousel-prev]');
      const next=section.querySelector('[data-cx-carousel-next]');
      if(!track) return;
      const step=()=>Math.max(280,Math.min(track.clientWidth*.72,430));
      prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
      next?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCollectionCarousels);
  else initCollectionCarousels();
})();

/* CARBON-X editable model comparison modal */
(() => {
  const getModal = section => section?.querySelector('[data-cx-compare-modal]');
  const openModal = (modal, trigger) => {
    if (!modal) return;
    modal.__cxLastFocus = trigger || document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('cx-modal-open');
    modal.querySelector('.cx-compare-modal__close')?.focus();
  };
  const closeModal = modal => {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('cx-modal-open');
    modal.__cxLastFocus?.focus?.();
  };

  document.addEventListener('click', e => {
    const openButton = e.target.closest('[data-cx-compare-open]');
    if (openButton) {
      e.preventDefault();
      e.stopPropagation();
      openModal(getModal(openButton.closest('[data-cx-compare-section]')), openButton);
      return;
    }

    const closeButton = e.target.closest('[data-cx-compare-close], .cx-compare-modal__close');
    if (closeButton) {
      e.preventDefault();
      closeModal(closeButton.closest('[data-cx-compare-modal]'));
    }
  });

  document.addEventListener('keydown', e => {
    const modal = document.querySelector('[data-cx-compare-modal]:not([hidden])');
    if (!modal) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal(modal);
      return;
    }
    if (e.key !== 'Tab') return;
    const focusables = [...modal.querySelectorAll('button,a,input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
